export enum ReportAttachType {
  None = 0,
  PDF = 3,
  CSV = 4,
  XLSX = 5,
}
